import classNames from 'classnames/bind';

import Styles from './styles.module.scss';
import defaultImage from '../../../assets/images/asset_class_default_image.png';

import withComponentName from '../../../decorators/withComponentName';

const cx = classNames.bind(Styles);

const loadError = (event) => {
  event.target.attributes.getNamedItem('src').value = defaultImage;
};

const setTitleClassName = (isCoverage) => (isCoverage ? cx(['item_title', 'coverage']) : cx('item_title'));

const SlideComponent = ({ item }) => {
  const { image, title, name, description, isComing, coverage} = item;
  const itemClassName = cx('item');
  const heading = title || name;
  return (
    <div className={itemClassName}>
      <img src={image || defaultImage} onError={loadError} />
      <div className={setTitleClassName(!!coverage)}>
        {heading}
      </div>
      {
        description && (
          <div className={Styles.item_description}>
            {description}
          </div>
        )
      }
      { isComing && <div className={Styles.comming_soon} /> }
      {
        coverage && (
          <div className={Styles.number}>
            {coverage}
          </div>
        )
      }
    </div>
  );
};

export default withComponentName(SlideComponent);
